// extracted by mini-css-extract-plugin
module.exports = {"item":"List_item__3C_Ga","items":"List_items__2nWMc","selected":"List_selected__3Rxdx"};